<section class="doubleSectionWrapper">
  <div class="profile_section">
    <div class="container">
      <div class="profile_wraper">
        <div class="profile">
          <div class="testDiv">
            <div class="profile_left">
              <img *ngIf="profile.imgUrl" [src]="profile.imgUrl" alt="profile">
              <img *ngIf="!profile.imgUrl" src="/assets/new-images/emptyProfile.png" alt="profile">
              <div class="text_parentDiv">
                <p class="prof_name">{{profile.name}}</p>
                <span class="about_text">ABOUT 
                  <svg width="14" height="6" viewBox="0 0 14 6" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 0L13.0622 6L0.937822 6L7 0Z" fill="#8B8A8F" />
                  </svg>
                </span>
              </div>
            </div>
            <div class="profile_text">
              <p *ngIf="!profile.bio">I joined Pakistan Sweet Home community since {{profile.created_at | date : 'mediumDate'}} to help end the growing orphan crises. Please
                consider
                joining me in supporting this cause. Your donations will go
                towards providing lifelong opportunities to deserving children.
              </p>
              <p *ngIf="profile.bio">{{profile.bio}}</p>
            </div>
          </div>
          <div class="view_account">
            <a routerLink="/dashboard" href="javascript:;" class="account_btn">View Account Dashboard</a>
          </div>
        </div>
  
        <div class="absolure_Div">
          <p class="join_text"> Join {{profile.firstName}} and bring change in the lives of
            the orphans </p>
          <a href="javascript:;" [routerLink]="'/donate/' + profile.ID" class="donate_btn">DONATE NOW</a>
        </div>
      </div>
    </div>
  </div>
  <div class="activity_section">
    <div class="container">
      <div  class="activity_wraper">
  
          <p class="activty_head">Latest Activity</p>
        <div class="donation_box_wraper" >
          <div class="Donation_box" *ngIf="donations">
            <p class="donation_count">{{donations.length}}</p>
            <div class="donation_innerText">
              <p class="donText">Total number of donations you've made</p>
              <span class="daysDon">{{latestDonationDate | dateAsAgo}}</span>
            </div>
          </div>
  
  
          <div class="Donation_box" *ngIf="referrals">
            <p class="donation_count">{{referrals.length}}</p>
            <div class="donation_innerText">
              <p class="donText">Total number of referrals you've sent</p>
              <span class="daysDon">{{latestReferralDate | dateAsAgo}}</span>
            </div>
          </div>
          <div class="Donation_box" *ngIf="totalContribution">
            <p class="donation_count">${{totalContribution}}</p>
            <div class="donation_innerText">
              <p class="donText">Total amount ($) you've contributed</p>
              <span class="daysDon">{{latestDonationDate | dateAsAgo}}</span>
            </div>
          </div>
          <div class="Donation_box" >
            <!-- <p class="donation_count">{{referrals.length}}</p> -->
            <div class="donation_innerText">
              <p class="donText">Joined Pakistan Sweet Home</p>
              <span class="daysDon">{{profile.created_at | dateAsAgo}}</span>
            </div>
          </div>
        </div>
  
  
      </div>
  
  
  
  
    </div>
  </div>
  <div class="privateOverlay" *ngIf="profile.profilePrivacy == '0' && profile.ID != currentUser?.ID ">
    <div class="privateModalContent">
      <svg width="111" height="111" viewBox="0 0 111 111" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1767_3941)">
        <path d="M55.5 6C42.3718 6 29.7813 11.2152 20.4982 20.4982C11.2152 29.7813 6 42.3718 6 55.5C6 68.6282 11.2152 81.2187 20.4982 90.5018C29.7813 99.7848 42.3718 105 55.5 105C68.6282 105 81.2187 99.7848 90.5018 90.5018C99.7848 81.2187 105 68.6282 105 55.5C105 42.3718 99.7848 29.7813 90.5018 20.4982C81.2187 11.2152 68.6282 6 55.5 6ZM48.3355 34.8859C50.0709 34.891 51.7658 35.4103 53.2062 36.3782C54.6466 37.346 55.7678 38.719 56.4283 40.3237C57.0889 41.9285 57.259 43.693 56.9173 45.3944C56.5756 47.0957 55.7374 48.6577 54.5085 49.883C53.2796 51.1082 51.7151 51.9418 50.0128 52.2785C48.3104 52.6152 46.5464 52.4398 44.9436 51.7745C43.3409 51.1092 41.9712 49.9839 41.0076 48.5406C40.044 47.0974 39.5297 45.401 39.5297 43.6656C39.5297 42.5104 39.7577 41.3666 40.2005 40.2997C40.6434 39.2328 41.2924 38.2638 42.1105 37.4482C42.9285 36.6325 43.8995 35.9864 44.9677 35.5467C46.0359 35.107 47.1804 34.8824 48.3355 34.8859ZM53.2074 60.9385V73.1832C53.2051 74.1852 53.5022 75.165 54.0606 75.9969H34.6579C33.6215 75.9969 32.6275 75.5852 31.8946 74.8523C31.1617 74.1194 30.75 73.1255 30.75 72.089C30.7552 67.7929 32.4654 63.6745 35.5051 60.6386C38.5447 57.6026 42.6651 55.8973 46.9613 55.8973H49.6707C51.5744 55.8972 53.4635 56.2301 55.2525 56.8808C54.6125 57.3522 54.0923 57.9673 53.7336 58.6767C53.375 59.386 53.188 60.1697 53.1878 60.9645L53.2074 60.9385ZM80.25 73.2093C80.25 73.9797 79.944 74.7186 79.3992 75.2633C78.8544 75.8081 78.1156 76.1142 77.3451 76.1142H58.2551C57.4846 76.1142 56.7458 75.8081 56.201 75.2633C55.6562 74.7186 55.3502 73.9797 55.3502 73.2093V60.9645C55.3502 60.1941 55.6562 59.4553 56.201 58.9105C56.7458 58.3657 57.4846 58.0597 58.2551 58.0597H59.4535V53.2204C59.4354 51.009 60.2831 48.8784 61.8155 47.2839C63.3479 45.6895 65.4432 44.7578 67.6536 44.6882C68.7596 44.6718 69.8578 44.8754 70.8844 45.2874C71.911 45.6993 72.8455 46.3113 73.6334 47.0877C74.4213 47.8641 75.0469 48.7894 75.4739 49.8098C75.9009 50.8302 76.1208 51.9254 76.1207 53.0315V54.6598C76.1225 54.8776 76.039 55.0874 75.888 55.2445C75.7371 55.4015 75.5307 55.4932 75.313 55.5H72.8576C72.6347 55.5 72.421 55.4115 72.2635 55.2539C72.1059 55.0963 72.0174 54.8826 72.0174 54.6598V53.0315C72.0172 52.4598 71.9009 51.8941 71.6755 51.3688C71.4501 50.8434 71.1203 50.3693 70.7061 49.9752C70.2919 49.5812 69.802 49.2754 69.2661 49.0763C68.7302 48.8773 68.1594 48.7893 67.5884 48.8175C66.4931 48.8923 65.4679 49.3833 64.7231 50.1899C63.9783 50.9965 63.5703 52.0575 63.5828 53.1553V58.0597H77.3451C78.1156 58.0597 78.8544 58.3657 79.3992 58.9105C79.944 59.4553 80.25 60.1941 80.25 60.9645V73.2093Z" fill="#A6AAB0"/>
        </g>
        <circle cx="55.5" cy="55.5" r="54.75" stroke="#A6AAB0" stroke-width="1.5"/>
        <defs>
        <clipPath id="clip0_1767_3941">
        <rect width="99" height="99" fill="white" transform="translate(6 6)"/>
        </clipPath>
        </defs>
        </svg>
        <h2>This user account is private.</h2>
        <p>The information that your are trying to access is not available.</p>
        <a href="javascript:;" routerLink="/donate">Make a Donation</a>
    </div>
  </div>
</section>
<section class="about_section">
  <div class="container">
    <div class="about_wraper">
      <div class="about_img" #wistiastar>
        <!-- <img src="assets/images/about_img.png" alt="">
        <a  class="video_btn" href="javascript:;"><svg width="54" height="38" viewBox="0 0 54 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M52.4235 5.86426C51.8067 3.57115 49.9987 1.76352 47.706 1.14606C43.5173 0 26.7626 0 26.7626 0C26.7626 0 10.0084 0 5.81982 1.10261C3.57115 1.71942 1.71909 3.57148 1.10228 5.86426C0 10.0525 0 18.7385 0 18.7385C0 18.7385 0 27.4682 1.10228 31.6128C1.71975 33.9055 3.52705 35.7132 5.82015 36.3306C10.0525 37.477 26.7632 37.477 26.7632 37.477C26.7632 37.477 43.5173 37.477 47.706 36.3744C49.9991 35.7573 51.8067 33.9496 52.4241 31.6569C53.5261 27.4682 53.5261 18.7826 53.5261 18.7826C53.5261 18.7826 53.5702 10.0525 52.4235 5.86426ZM21.4097 26.8866L21.4282 10.7141L35.3509 18.4223L21.4097 26.8866Z"
              fill="#00AAE9" fill-opacity="0.8" />
            <path d="M21.4099 26.8871V10.7009L35.351 18.4223L21.4099 26.8871Z" fill="white" fill-opacity="0.8" />
          </svg>
        </a> -->
        <div class="wistia_embed wistia_async_k3l6f2s6hx seo=false" style="height:240px;position:relative;width:427px"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/k3l6f2s6hx/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div>
      </div>
      <div class="aboutText">
        <p class="aboutHead">ABOUT PAKISTAN SWEET HOME</p>
        <p class="about_desc secondText">Pakistan Sweet Home started as a project of
          Bait-ul-Mal in 2009 when a single child from Swat, KPK, was handed over to Mr. Zamurrad Khan.</p>
        <p class="about_desc">As one of the first SECP-registered orphanages in Pakistan, our work has made a huge
          difference in young lives that may have been lost.</p>
      </div>
    </div>
  </div>
</section>
